// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2F3AM","name":"Header_name__11tvL","birthday":"Header_birthday__2vQs3","skeleton":"Header_skeleton__5C_1z"};